import { apiClient } from './apiClient'

/****************************************************************************
 * 
 * User manifest
 * 
 ***************************************************************************/
export const userManifestApi = {
    fetchUserManifestByAccessToken: async (config, accessToken) => {
        const url = `${config.securityApiUrl}/userManifests?accessToken=${accessToken}`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (c) => {
                        return c.userManifest[0]
                    }
                )
            }
        )
    }
}